/**
 * Role → page access. Single source of truth for App.tsx's "Acceso Restringido"
 * gate and for any link/breadcrumb that should not offer a page the role can't open.
 */
import type { Page, UserRole } from '../types';

export const RESTRICTED_PAGES: Partial<Record<UserRole, readonly Page[]>> = {
  auditor: [
    'overview', 'admin', 'settings', 'reports', 'executive', 'operations', 'district',
    'command-center', 'forensics', 'supply-chain', 'vsm', 'constructor-kpis',
    'constructor-reglas', 'risk-tower-pack', 'diagnostico',
  ],
  // Store managers CAN access 'overview', 'district', 'dashboard', 'floor'
  store_manager: [
    'admin', 'settings', 'reports', 'cashier-performance', 'executive', 'operations',
    'command-center', 'forensics', 'constructor-kpis', 'constructor-reglas',
    'risk-tower-pack', 'diagnostico',
  ],
};

export function canAccessPage(role: UserRole | null | undefined, page: Page): boolean {
  if (!role) return true; // App.tsx applies its own default role before gating
  return !(RESTRICTED_PAGES[role]?.includes(page) ?? false);
}
